export const cleanPhone = value => {
  if (value === null || value === undefined) return ''
  const strVal = String(value)
  const digits = strVal.replace(/\D/g, '')
  // Strip leading US country code (1) if 11 digits starting with 1
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1)
  return digits
}

export const formatPhone = value => {
  if (value === null || value === undefined) return ''

  const str = String(value).trim()
  if (!str) return ''

  // Preserve optional extension like "x123", "ext. 4", "#501"
  const extMatch = str.match(/(?:x|ext\.?|#)\s*(\d+)$/i)
  const ext = extMatch ? ` x${extMatch[1]}` : ''
  const base = extMatch ? str.slice(0, extMatch.index) : str

  const clean = cleanPhone(base)

  if (clean.length === 10) {
    const match = clean.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}${ext}`
    }
  }

  return value
}
